import React, {useContext, useEffect, useState, useRef} from "react";
import {useNavigate, Link} from "react-router-dom";

import logo from "./../../../Public/img/logo-black.png";
import userlogo from "./../../../Public/img/avatar-14.jpg";
import { AuthContext } from "../../../context/AuthContext";
import {globalSearchAPI} from "./../../../API/Sales/LeadAPI";


const Header = () =>{

    const navigate = useNavigate();
    const {user, setUser} = useContext(AuthContext);
    const [showprofiledropdown, setShowProfileDropDown] = useState(false);
    const [loggedname, setLoggedName] = useState("");
    const [prifileimage, setProfileImage] = useState("");
    const [txtsearchemail, setTxtSearchEmail] = useState("");
    const [txtglobalsearchtype, setTxtGlobalSearchType] = useState("email");
    const [teamType, setTeamType] = useState( localStorage.getItem("team_type") || "Executive");
    const profiledropdownRef = useRef(null);
    const profileimagepath = "http://api.edustack360.local/uploads/profile/";

    const dashboardurl = `${window.location.origin}/sales/dashboard`;

    useEffect(() =>{
    
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);

        function handleClickOutside(event)
        {
            if (profiledropdownRef.current && !profiledropdownRef.current.contains(event.target)) 
            {
                setShowProfileDropDown(false);
            }
        }

    }, []);

    useEffect(()=>{

        const userinfo = localStorage.getItem("userinfo");

        if(userinfo !== "" && userinfo !== null && userinfo !== undefined)
        {
            const loggeduserdata = JSON.parse(userinfo);

            setLoggedName(loggeduserdata.name);

            setProfileImage(loggeduserdata.image);

            //console.log('User info===='+loggeduserdata);
            //console.log('User info===='+loggeduserdata.name);
        }

    }, [])


    const handleShowProfileToggle = ()=>{
        setShowProfileDropDown(!showprofiledropdown);
    }

    const handleLogout = () =>{

        localStorage.removeItem('cpmstoken');
        //sessionStorage.removeItem('cpmstoken');
        localStorage.removeItem('userinfo');
        setUser(null);
        navigate('/sign-in', { replace: true });
    }

    const handleSearchEmail = (e) =>{
        setTxtSearchEmail(e.target.value);
    }

    const handleSearchLead = (e) =>{
        e.preventDefault();

        const formData = new FormData();
        formData.append('searchemail', txtsearchemail);
        formData.append('teamtype', teamType);
        formData.append('searchtype', txtglobalsearchtype);

        globalSearchAPI(formData, navigate);

        setTxtSearchEmail("");
    }

    const handleGlobalSearchType = (e) =>{
        e.preventDefault();

        setTxtGlobalSearchType(e.target.value);
    }

    const handleTeamTypeChange = (e) => {

        const newTeamType = e.target.checked ? "ODL" : "Executive";

        localStorage.setItem("team_type", newTeamType);

        setTeamType(newTeamType);

        window.location.reload();
    };

    return (
    <div className="header">
        

        <Link id="mobile_btn" className="mobile_btn" to="#sidebar">
            <span className="bar-icon">
                <span></span>
                <span></span>
                <span></span>
            </span>
        </Link>

        <div className="header-user">
            <ul className="nav user-menu">

                <li className="nav-item nav-search-inputs me-auto">
                    <div class="">
                        <select className="form-select" name="leadcaller-filter" value={txtglobalsearchtype} onChange={handleGlobalSearchType}>
                            <option value="email">Email</option>
                            <option value="contact">Contact</option>
                        </select>
                    </div>
                    <div class="crm-search-box">
                        <input type="text" name="searchemail" id="searchemail" value={txtsearchemail} onChange={handleSearchEmail} placeholder="Search by email..." />

                        <span class="crm-search-icon" onClick={handleSearchLead}>
                            <i class="fas fa-search"></i>
                        </span>
                    </div>     
                </li>

                <li className="nav-item">
                    <div className="d-flex align-items-center gap-2">

                    <span className="small fw-semibold">
                        {teamType}
                    </span>

                    <div className="form-check form-switch mb-0">
                        <input className="form-check-input" type="checkbox" role="switch" id="teamTypeSwitch"
                            checked={teamType === "ODL"} onChange={handleTeamTypeChange}  />
                    </div>

                </div>
                </li>

                {/*<li className="nav-item crm-top-icon">🔔</li>*/}

                <li className="nav-item dropdown has-arrow main-drop">
                    <div className="dropdown profile-dropdown d-flex align-items-center justify-content-center" ref={profiledropdownRef}>
                        <div className={showprofiledropdown ? "topbar-link drop-arrow-none position-relative show" : "topbar-link  drop-arrow-none position-relative"} onClick={handleShowProfileToggle} >
                            
                            <img src={userlogo} width="38" className="rounded-1 d-flex" alt="user-image" />

                            <span class="online text-success">
                                <i class="ti ti-circle-filled d-flex bg-white rounded-circle border border-1 border-white"></i>
                            </span>
                            
                        </div>

                        {showprofiledropdown ?
                        <div class="dropdown-menu dropdown-menu-end dropdown-menu-md p-2 show" data-popper-placement="bottom-end" style={{ position: "absolute", inset: "0px 0px auto auto", margin: "0px", transform: "translate3d(0px, 60px, 0px)" }}>
                        
                            <div class="d-flex align-items-center bg-light rounded-3 p-2 mb-2">
                                {prifileimage !== "" && prifileimage !==  null && prifileimage !== undefined ?
                                <img src={profileimagepath + prifileimage} width="38" className="rounded-circle d-flex" alt="user-image" />
                                :
                                <img src={userlogo} width="38" className="rounded-circle d-flex" alt="user-image" />

                                }
                                <div class="ms-2">
                                    <p class="fw-medium text-dark mb-0">{loggedname}</p>
                                    <span class="d-block fs-13">Caller</span>
                                </div>
                            </div>

                            <Link to="/sales/profile" class="dropdown-item">
                                <i class="ti ti-user-circle me-1 align-middle"></i>
                                <span class="align-middle">Profile Settings</span>
                            </Link>                                           
                            
                            <div class="pt-2 mt-2 border-top">
                                <button class="dropdown-item text-danger" onClick={handleLogout}>
                                    <i class="ti ti-logout me-1 fs-17 align-middle"></i>
                                    <span class="align-middle">Sign Out</span>
                                </button>
                            </div>
                        </div>
                        :
                        <div class="dropdown-menu dropdown-menu-end dropdown-menu-md p-2" data-popper-placement="bottom-end" style={{ position: "absolute", inset: "0px 0px auto auto", margin: "0px", transform: "translate3d(0px, 60px, 0px)" }}>
                        
                            <div class="d-flex align-items-center bg-light rounded-3 p-2 mb-2">
                                <img src={userlogo} class="rounded-circle" width="42" height="42" alt="Img" />
                                <div class="ms-2">
                                    <p class="fw-medium text-dark mb-0">{loggedname}</p>
                                    <span class="d-block fs-13">Caller</span>
                                </div>
                            </div>

                            <Link to="/sales/profile" class="dropdown-item">
                                <i class="ti ti-user-circle me-1 align-middle"></i>
                                <span class="align-middle">Profile Settings</span>
                            </Link>
        
                            
                            <div class="pt-2 mt-2 border-top">
                                <button class="dropdown-item text-danger" onClick={handleLogout}>
                                    <i class="ti ti-logout me-1 fs-17 align-middle"></i>
                                    <span class="align-middle">Sign Out</span>
                                </button>
                            </div>
                        </div>
                        }
                    </div>
                </li>
            </ul>
        </div>
    </div>
    )

}

export default Header;